import { render } from "./report_configuration.vue?vue&type=template&id=460bb65f&scoped=true"
import script from "./report_configuration.vue?vue&type=script&lang=js"
export * from "./report_configuration.vue?vue&type=script&lang=js"

import "./report_configuration.vue?vue&type=style&index=0&id=460bb65f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460bb65f"]])

export default __exports__